define.alias("shared/components/shared/appstore-links", "media/components/shared/appstore-links");